module.exports = __webpack_public_path__ + "8bf1fcd9d47f7bc478ef13f88c9a1a72.pdf";